import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import HelpOutline from "@material-ui/icons/HelpOutline";

const useStyles = makeStyles(() => ({
    footer: {
        padding: "18px 28px",
        borderTop: "1px solid rgba(255,255,255,0.06)",
        background: "linear-gradient(180deg, #0f1117 0%, #0b0d12 100%)",
    },
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        fontFamily: "'Inter', sans-serif",
    },
    left: {
        fontSize: "12.5px",
        color: "rgba(255,255,255,0.6)",
        letterSpacing: "0.3px",
    },
    right: {
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
    },
    link: {
        fontSize: "12.5px",
        textDecoration: "none",
        color: "rgba(255,255,255,0.75)",
        letterSpacing: "0.3px",
        position: "relative",
        transition: "all 0.25s ease",

        "&:hover": {
            color: "#c084fc",
        },

        // 🔥 Underline Animation
        "&::after": {
            content: '""',
            position: "absolute",
            width: "0%",
            height: "1px",
            bottom: "-2px",
            left: 0,
            backgroundColor: "#c084fc",
            transition: "width 0.25s ease",
        },

        "&:hover::after": {
            width: "100%",
        },
    },
}));

export default function Footer() {
    const classes = useStyles();

    return (
        <footer className={classes.footer}>
            <div className={classes.container}>
                <div className={classes.left}>
                    © {new Date().getFullYear()} KI-Marktanalyse-Terminal v1.0.1
                </div>

                <div className={classes.right}>
                    <Link to="/admin/impressum" className={classes.link}>Impressum</Link>
                    <Link to="/admin/datenschutz" className={classes.link}>Datenschutz</Link>
                    <Link to="/admin/nutzungsbedingungen" className={classes.link}>Nutzungsbedingungen</Link>
                    <Link to="/admin/disclaimer" className={classes.link}>Disclaimer</Link>
                    <Link to="/admin/risikohinweis" className={classes.link}>Risikohinweis</Link>
                    <Link to="/admin/ki-hinweis" className={classes.link}>KI-Hinweis</Link>
                    <Link to="/admin/hilfe" className={classes.link} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                        <HelpOutline style={{ fontSize: 16 }} />
                        Hilfe
                    </Link>
                </div>
            </div>
        </footer>
    );
}